import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../../Language/LanguageProvider';
import contactFormSchema from './contactFormValidation';

const useStyle = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
    '& .MuiInputBase-input': {
      color: 'white',
    },
  },
  formContainer: {
    background: theme.palette.primary.dark,
  },
  formTitle: {
    marginTop: '1em',
  },
}));

const ContactForm = () => {
  const classes = useStyle();
  const { dictionary } = useContext(LanguageContext);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    contactFormSchema
      .isValid({
        name: name,
        email: email,
        message: message,
      })
      .then(valid => {
        if (valid) setIsValid(true);
        else setIsValid(false);
      });
  }, [name, email, message]);

  return (
    <form
      name="contact"
      action="/contact"
      method="post"
      className={classes.root}
      noValidate
      autoComplete="off"
    >
      <input required type="hidden" name="form-name" value="contact" />

      <Grid
        className={classes.formContainer}
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item className={classes.formTitle}>
          <Typography variant="h5" align="center">
            {dictionary['contact-form-title']}
          </Typography>
        </Grid>

        <Grid item>
          <TextField
            required
            autoComplete="off"
            id="name"
            name="name"
            label={dictionary['contact-form-name']}
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Grid>

        <Grid item>
          <TextField
            type="email"
            autoComplete="off"
            required
            name="email"
            id="email"
            label="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Grid>

        <Grid item>
          <TextField
            multiline
            required
            name="message"
            label={dictionary['contact-form-message']}
            id="message"
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </Grid>

        <Grid item>
          <Button type="submit" color="inherit" disabled={!isValid}>
            {dictionary['contact-form-send']}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ContactForm;
